import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

//Internal
import { setTimeAMPMWithoutZero } from "utils";
import CommonBookingAddress from "./commonBookingAddress";

const BookingAddress = ({
  step,
  formik,
  stateShortName,
  dropoffStateShortName,
  startDate,
  startTimeDefaultValue,
  endDate,
  endTimeDefaultValue,
  vehicalDetailData,
  days,
}) => {
  const addressInfo = useSelector((state) => state?.common?.addressInfo);
  const [pickupAddress, setPickupAddress] = useState("");
  const [returnAddress, setReturnAddress] = useState("");
  const startDateTime = startDate
    ? startDate + " at " + setTimeAMPMWithoutZero(startTimeDefaultValue)
    : "";
  const endDateTime = endDate
    ? endDate + " at " + setTimeAMPMWithoutZero(endTimeDefaultValue)
    : "";

  const startAddressLine1 = formik.values.address
    ? formik.values.address + ", "
    : "";
  const startAddressLine2 = formik.values.city
    ? formik.values.city + ", " + stateShortName + " " + formik.values.zipcode
    : "";

  const returnAddressLine1 = formik.values.return_address
    ? formik.values.dropoff_address + ", "
    : "";
  const returnAddressLine2 = formik.values.dropoff_city
    ? formik.values.dropoff_city +
      ", " +
      dropoffStateShortName +
      " " +
      formik.values.dropoff_zipcode
    : "";
  /*******************
   @Purpose : Call pickup handler
   @Parameter : {}
   @Author : INIC
 *******************/
  useEffect(() => {
    if (
      formik?.values?.address &&
      formik?.values?.city &&
      formik?.values?.zipcode
    ) {
      pickupHandler();
    }
  }, [formik?.values?.address, formik?.values?.city, formik?.values?.zipcode]);

  /*******************
   @Purpose : Call dropup handler
   @Parameter : {}
   @Author : INIC
 *******************/
  useEffect(() => {
    if (
      formik?.values?.dropoff_address &&
      formik?.values?.dropoff_city &&
      formik?.values?.dropoff_zipcode
    ) {
      dropUpHandler();
    }
  }, [
    formik?.values?.dropoff_address,
    formik?.values?.dropoff_city,
    formik?.values?.dropoff_zipcode,
  ]);

  /*******************
   @Purpose : Set journey start address
   @Parameter : {}
   @Author : INIC
 *******************/
  useEffect(() => {
    if (formik?.values?.pickup_option) {
      pickupHandler();
    } else {
      setPickupAddress(addressInfo?.company_address);
    }
  }, [formik?.values?.pickup_option]);

  /*******************
   @Purpose : Pickup handler
   @Parameter : {}
   @Author : INIC
 *******************/
  const pickupHandler = () => {
    if (formik?.values?.address) {
      let add =
        formik.values.address +
        ", " +
        formik.values.city +
        ", " +
        stateShortName +
        " " +
        formik.values.zipcode;
      setPickupAddress(add);
    } else {
      setPickupAddress(addressInfo?.company_address);
    }
  };

  /*******************
   @Purpose : Set Journey end address 
   @Parameter : {}
   @Author : INIC
 *******************/
  useEffect(() => {
    if (formik?.values?.dropoff_option == "sameaspickup") {
      setReturnAddress(pickupAddress);
    }

    if (formik?.values?.is_pickup_selected && formik?.values?.is_one_way) {
      dropUpHandler();
    }

    if (formik?.values?.dropoff_option == "delivery") {
      dropUpHandler();
    }
  }, [formik?.values?.dropoff_option]);

  /*******************
   @Purpose : Dropup handler
   @Parameter : {}
   @Author : INIC
 *******************/
  const dropUpHandler = () => {
    if (formik?.values?.dropoff_address) {
      let rAdd =
        formik.values.dropoff_address +
        ", " +
        formik.values.dropoff_city +
        ", " +
        dropoffStateShortName +
        " " +
        formik.values.dropoff_zipcode;

      setTimeout(() => {
        setReturnAddress(rAdd);
      }, 100);
    }
  };

  return (
    <CommonBookingAddress
      step={step}
      startDateTime={startDateTime}
      endDateTime={endDateTime}
      pickupAddress={formik?.values?.address}
      startAddressLine1={startAddressLine1}
      startAddressLine2={startAddressLine2}
      returnAddress={formik?.values?.dropoff_address}
      formik={formik}
      vehicalDetailData={vehicalDetailData}
      days={days}
      returnAddressLine1={returnAddressLine1}
      returnAddressLine2={returnAddressLine2}
    />
  );
};

export default BookingAddress;
